import { Component, Vue, Prop } from 'vue-property-decorator';
import Share from '@/components/Share/Share.vue';

import { format } from 'date-fns';
// icons
import Listen from '@/assets/icons/listen.svg?inline';
import Watch from '@/assets/icons/watch.svg?inline';
import Read from '@/assets/icons/read2.svg?inline';
import Wildlife from '@/assets/icons/binoculars.svg?inline';
import DER from '@/assets/icons/article.svg?inline';
import WorldView from '@/assets/icons/globe.svg?inline';
import Culture from '@/assets/icons/culture.svg?inline';
import Video360 from '@/assets/icons/binoculars.svg?inline';
import Calendar from '@/assets/icons/calendar.svg?inline';
import Rectangles from '@/assets/icons/rectangles.svg?inline';
import IconCalendar from '@/assets/icons/calendar.svg?inline';
import Ship from '@/assets/icons/ship.svg?inline';
import Pin from '@/assets/icons/pin-fixed.svg?inline';
import Compass from '@/assets/icons/compass.svg?inline';

import { HeroArticleBlockViewModel } from '@/modules/HeroArticleModule/HeroArticleModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import ContentCategory from '@/common/interfaces/enums/ContentCategory';
import ContentType from '@/common/interfaces/enums/ContentType';

const ArticleHeaderProps = Vue.extend({
  props: getComponentProps<HeroArticleBlockViewModel>({
    Header: 'How the travel industry can help fight climate change',
    Date: '16 JUN 2019',
    IsCreatedDateVisible: true,
    Ship: null,
    Location: 'Alaska',
    Coordinates: [{ Latitude: '2222', Longitude: '22222' }],
    Category: ContentCategory.WildLife,
    Type: ContentType.Read,
    Minutes: 4,
    BackLink: '#',
  }),
});

@Component({
  components: {
    Share,
    Read,
    IconCalendar,
    Ship,
    Pin,
    Compass,
    Listen,
    Watch,
    Video360,
    Wildlife,
    DER,
    WorldView,
    Culture,
    Calendar,
    Rectangles,
  },
})
export default class ArticleHeader extends ArticleHeaderProps {

  @Prop()
  readonly Header!: string;
  @Prop()
  readonly Ship!: string;
  @Prop()
  readonly Location!: string;
  @Prop()
  readonly Date!: string;
  @Prop()
  readonly Coordinates!: Object;
  @Prop()
  readonly Minutes!: number;

  get HeaderData() {
    return this.p;
  }

  get Type() {
    switch (this.p.Type) {
      case ContentType.Read:
        return 'Read';
      case ContentType.Watch:
        return 'Watch';
      case ContentType.Listen:
        return 'Listen';
      case ContentType.Video360:
        return 'Video360';
      default:
        return null;
    }
  }

  get reformattedDate() {
    const date = new Date(this.Date);
    return format(date, 'dd MMM Y');
  }

  get coordinates() {
    if (!this.Coordinates || !this.Coordinates['Latitude'] || !this.Coordinates['Longitude']) {
      return '';
    }
    
    let Latitude = this.Coordinates['Latitude'];
    let Longitude = this.Coordinates['Longitude'];
    if (!Latitude || !Longitude) return null;
    if (parseFloat(Latitude) < 0) {
      Latitude = Math.abs(parseFloat(Latitude)).toString() + '° S';
    } else if (parseFloat(Latitude) > 0) {
      Latitude = Math.abs(parseFloat(Latitude)).toString() + '° N';
    }
    if (parseFloat(Longitude) < 0) {
      Longitude = Math.abs(parseFloat(Longitude)).toString() + '° W';
    } else if (parseFloat(Longitude) > 0) {
      Longitude = Math.abs(parseFloat(Longitude)).toString() + '° E';
    }
    return Latitude + ', ' + Longitude;
  }
}
